import { COLOR_MAP } from '../@loadAvatar/loadAvatarUtil';
import {
    IMemberMAP,
    MEMBER_TYPE,
    MEMBER_ASSESSMENT_TYPE,
    IUserTypeMAP,
    IMemberIdMap,
    MEMBER_ID_TYPE,
} from './interface';
const pageData = {
    pageInfoDefault: {
        currentPage: 0,
        listTotalNum: 0,
        size: 100,
        totalPageNum: 1,
    },
};
const memberMap: IMemberMAP = {
    [MEMBER_TYPE.USER]: MEMBER_ASSESSMENT_TYPE.MEMBER,
    [MEMBER_TYPE.GROUP]: MEMBER_ASSESSMENT_TYPE.GROUP,
    [MEMBER_TYPE.DEPARTMENT]: MEMBER_ASSESSMENT_TYPE.DEPART,
    [MEMBER_TYPE.CLASS]: MEMBER_ASSESSMENT_TYPE.CLASS,
};

const userTypeMap: IUserTypeMAP = {
    [MEMBER_ASSESSMENT_TYPE.MEMBER]: MEMBER_TYPE.USER,
    [MEMBER_ASSESSMENT_TYPE.GROUP]: MEMBER_TYPE.GROUP,
    [MEMBER_ASSESSMENT_TYPE.DEPART]: MEMBER_TYPE.DEPARTMENT,
    [MEMBER_ASSESSMENT_TYPE.CLASS]: MEMBER_TYPE.CLASS,
};

const userTypeIdMap: IMemberIdMap = {
    [MEMBER_ASSESSMENT_TYPE.MEMBER]: MEMBER_ID_TYPE.USER,
    [MEMBER_ASSESSMENT_TYPE.GROUP]: MEMBER_ID_TYPE.GROUP,
    [MEMBER_ASSESSMENT_TYPE.DEPART]: MEMBER_ID_TYPE.DEPARTMENT,
    [MEMBER_ASSESSMENT_TYPE.CLASS]: MEMBER_ID_TYPE.CLASS,
};

export { pageData, memberMap, COLOR_MAP, userTypeMap, userTypeIdMap };
